import { Container, NotesPost, Section } from "@humaniti/ui";
import { Navigate, useParams } from "react-router-dom";
import { NOTES, findPost } from "../content/notes";
import { SEO, articleJsonLd } from "../lib/seo";

export const FieldNotesPostPage = () => {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return <Navigate to="/notes" replace />;
  const post = findPost(slug);
  if (!post) return <Navigate to="/notes" replace />;
  const idx = NOTES.findIndex((n) => n.frontmatter.slug === slug);
  // NOTES is sorted newest-first, so idx + 1 is older, idx - 1 is newer.
  const prev = NOTES[idx + 1]?.frontmatter;
  const next = NOTES[idx - 1]?.frontmatter;
  const PostBody = post.Component;
  return (
    <>
      <SEO
        title={`${post.frontmatter.title} — Field notes`}
        description={post.frontmatter.excerpt}
        path={`/notes/${post.frontmatter.slug}`}
        ogType="article"
        jsonLd={articleJsonLd({
          headline: post.frontmatter.title,
          description: post.frontmatter.excerpt,
          url: `https://humaniti.io/notes/${post.frontmatter.slug}`,
          datePublished: post.frontmatter.date,
          byline: post.frontmatter.byline,
        })}
      />
      <Section>
        <Container size="default">
          <NotesPost
            number={post.frontmatter.number}
            title={post.frontmatter.title}
            byline={post.frontmatter.byline}
            date={post.frontmatter.date}
            readingMinutes={post.frontmatter.readingMinutes}
            signature="— The Humans of Humaniti"
            prev={prev ? { slug: prev.slug, title: prev.title } : undefined}
            next={next ? { slug: next.slug, title: next.title } : undefined}
          >
            <PostBody />
          </NotesPost>
        </Container>
      </Section>
    </>
  );
};
